import { configureStore } from '@reduxjs/toolkit';
import contentReducer from './slice/contentSlice';
export const store = configureStore({
    reducer: {
        content: contentReducer,
    },
});
